module.exports = __webpack_public_path__ + "img/rule_02.88ad4e5c.png";